// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
Case Usage Example:
h1 { @include font-roboto(400); }
**/
h1 {
  font-size: 2rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h1 {
    font-size: 1.5rem;
  }
}

h2 {
  font-size: 1.8rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h2 {
    font-size: 1.2rem;
  }
}

.button-link {
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  background-color: #aa004f;
  cursor: pointer;
  border-radius: 50px;
  text-transform: uppercase;
  font-size: 2rem;
  display: inline-flex;
  align-content: center;
  justify-content: center;
  padding: 15px 25px;
  color: white;
  text-decoration: none;
  align-items: center;
  text-align: center;
  gap: 5px;
}
.button-link.white, .button-link.white2 {
  background: white;
  color: #aa004f;
}
.button-link.white2 {
  border: 2px solid #aa004f;
}
.button-link.gray {
  background: #bebebe;
  border: 2px solid #bebebe;
}
.button-link.primary, .button-link.gray-2, .button-link.trans, .button-link.green {
  cursor: pointer;
  border-radius: 50px;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 35px;
  text-align: center;
  border: 0;
  color: white;
  background: #37AA1E;
  gap: 5px;
  font-weight: initial;
  font-size: 1rem;
  background: #aa004f;
}
.button-link.outline {
  cursor: pointer;
  border-radius: 50px;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 35px;
  text-align: center;
  color: #aa004f;
  gap: 5px;
  font-weight: initial;
  font-size: 1rem;
  background: white;
  border: 1px solid #aa004f;
}
.button-link.outline:hover {
  color: white;
  background: #aa004f;
  border: 1px solid #aa004f;
}
.button-link.green {
  background: #37AA1E;
}
.button-link.trans {
  background: transparent;
  color: black;
  border: 1px solid black;
}
.button-link.gray-2 {
  background: #E4E5F1;
  color: black;
}
.button-link.sm {
  font-size: 1.5rem;
  padding: 20px;
  height: 65px;
}
.button-link.sm2 {
  font-size: 0.8rem;
  padding: 10px;
  height: auto;
  max-width: 200px;
  margin-bottom: 25px;
}
.button-link.sm3 {
  font-size: 1rem;
  padding: 15px 50px;
}
.button-link.sm4 {
  font-size: 0.8rem;
  padding: 10px 20px;
}

.left-call .hide-desktop {
  display: none;
}

@media (max-width: 992px) {
  .button {
    font-size: 1rem;
    padding: 10px 35px;
  }
  .show-mobile {
    display: block !important;
    padding: 10px 35px;
  }
  .button-link.sm3 {
    padding: 10px 35px;
  }
  .button-link.sm4 {
    font-size: 0.8rem;
    padding: 10px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/fonts.scss","webpack://./src/widgets/ButtonLink/styles.scss","webpack://./src/css/colors.scss"],"names":[],"mappings":"AAMA;;;EAAA;AASA;EACE,eAAA;EACA,aAAA;ACTF;ADUE;EAHF;IAII,iBAAA;ECPF;AACF;;ADSA;EACE,iBAAA;EACA,aAAA;ACNF;ADOE;EAHF;IAII,iBAAA;ECJF;AACF;;AAnBA;EDDE,iCAAA;EACA,gBCCqB;EAErB,yBCIQ;EDHR,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AAsBF;AArBE;EACE,iBAAA;EACA,cClBK;ADyCT;AArBE;EAEE,yBAAA;AAsBJ;AApBE;EACE,mBCxBK;EDyBL,yBAAA;AAsBJ;AApBE;EACE,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,mBChCM;EDiCN,QAAA;EACA,oBAAA;EACA,eAAA;EACA,mBCrCM;AD2DV;AApBE;EACE,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cChDM;EDiDN,QAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAsBJ;AArBI;EACE,YAAA;EACA,mBCxDI;EDyDJ,yBAAA;AAuBN;AApBE;EAEE,mBC7DM;ADkFV;AAnBE;EAEE,uBAAA;EACA,YAAA;EACA,uBAAA;AAoBJ;AAlBE;EAEE,mBCtEM;EDuEN,YAAA;AAmBJ;AAjBE;EACE,iBAAA;EACA,aAAA;EACA,YAAA;AAmBJ;AAjBE;EACE,iBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAmBJ;AAjBE;EACE,eAAA;EACA,kBAAA;AAmBJ;AAjBE;EACE,iBAAA;EACA,kBAAA;AAmBJ;;AAhBA;EACE,aAAA;AAmBF;;AAjBA;EACE;IACE,eAAA;IACA,kBAAA;EAoBF;EAlBA;IACE,yBAAA;IACA,kBAAA;EAoBF;EAjBE;IACE,kBAAA;EAmBJ;EAjBE;IACE,iBAAA;IACA,kBAAA;EAmBJ;AACF","sourcesContent":["@import \"./breakpoints\";\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap');\n@mixin font-roboto($weight) {\n  font-family: 'Roboto', sans-serif;\n  font-weight: $weight;\n}\n/**\nCase Usage Example:\nh1 { @include font-roboto(400); }\n**/\n\n$font-sm:1.1rem;\n$font-md:1.2rem;\n$font-lg:1.3rem;\n\nh1 {\n  font-size: 2rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.5rem;\n  }\n}\nh2 {\n  font-size: 1.8rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.2rem;\n  }\n}\n","@import \"../../css/breakpoints\";\n@import \"../../css/colors\";\n@import \"../../css/fonts\";\n\n.button-link {\n  @include font-roboto(900);\n  //background: linear-gradient(to right, #d02050 0%, #e34634 100%);\n  background-color: $color12;\n  cursor: pointer;\n  border-radius: 50px;\n  text-transform: uppercase;\n  font-size: 2rem;\n  display: inline-flex;\n  align-content: center;\n  justify-content: center;\n  padding: 15px 25px;\n  color: white;\n  text-decoration: none;\n  align-items: center;\n  text-align: center;\n  gap: 5px;\n  &.white {\n    background: white;\n    color: $color6;\n  }\n  &.white2 {\n    @extend .white;\n    border: 2px solid $color6;\n  }\n  &.gray {\n    background: $color7;\n    border: 2px solid $color7;\n  }\n  &.primary {\n    cursor: pointer;\n    border-radius: 50px;\n    text-transform: uppercase;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 35px;\n    text-align: center;\n    border: 0;\n    color: white;\n    background: $color13;\n    gap: 5px;\n    font-weight: initial;\n    font-size: 1rem;\n    background: $color12;\n  }\n  &.outline {\n    cursor: pointer;\n    border-radius: 50px;\n    text-transform: uppercase;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 35px;\n    text-align: center;\n    color: $color12;\n    gap: 5px;\n    font-weight: initial;\n    font-size: 1rem;\n    background: white;\n    border: 1px solid $color12;\n    &:hover {\n      color: white;\n      background: $color12;\n      border: 1px solid $color12;\n    }\n  }\n  &.green {\n    @extend .primary;\n    background: $color13;\n  }\n  &.trans {\n    @extend .primary;\n    background: transparent;\n    color: black;\n    border: 1px solid black;\n  }\n  &.gray-2 {\n    @extend .primary;\n    background: $color14;\n    color: black;\n  }\n  &.sm {\n    font-size: 1.5rem;\n    padding: 20px;\n    height: 65px;\n  }\n  &.sm2 {\n    font-size: 0.8rem;\n    padding: 10px;\n    height: auto;\n    max-width: 200px;\n    margin-bottom: 25px;\n  }\n  &.sm3 {\n    font-size: 1rem;\n    padding: 15px 50px;\n  }\n  &.sm4 {\n    font-size: 0.8rem;\n    padding: 10px 20px;\n  }\n}\n.left-call .hide-desktop {\n  display: none;\n}\n@media (max-width: $lg) {\n  .button {\n    font-size: 1rem;\n    padding: 10px 35px;\n  }\n  .show-mobile {\n    display: block !important;\n    padding: 10px 35px;\n  }\n  .button-link {\n    &.sm3 {\n      padding: 10px 35px;\n    }\n    &.sm4 {\n      font-size: 0.8rem;\n      padding: 10px 20px;\n    }\n  }\n}\n","$color1: #e34634;\n$color2: #d02050;\n$color3: #46b1ff;\n$color4: #f5eee7;\n$color5: #baad9e;\n$color6: #aa004f;\n$color7: #bebebe;\n$color8: #d6d6d6;\n$color9: #f8f7f7;\n$color10: #202121;\n$color11: #848484;\n$color12: #aa004f;\n$color13: #37AA1E;\n$color14: #E4E5F1;\n$color15: #CB186B;\n$color16: #FCD3CA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
